import React, { useState } from 'react';
import SITE from '../services/siteConfig';
import styles from './Support.module.css';

const faqData = [
  { q: "What types of massage do you offer?", a: "We offer Swedish, Deep Tissue, Sports, Prenatal, Hot Stone, and Therapeutic Massage, all tailored to your specific needs." },
  { q: "How do I book an appointment?", a: "You can book online through our website, call us directly, or visit our location in person." },
  { q: "What should I expect during my first visit?", a: "Your therapist will review your health history, discuss your goals, and customize your session for maximum comfort and effectiveness." },
  { q: "Do you accept insurance or HSA/FSA payments?", a: "Yes, we accept HSA/FSA payments and can provide receipts for insurance reimbursement if applicable." },
  { q: "What is your cancellation policy?", a: "We require 24-hour notice for cancellations to avoid a fee. Late cancellations may incur a 50% charge." },
  { q: "How often should I get a massage?", a: "For general wellness, every 4–6 weeks is ideal. For pain relief or injury recovery, weekly or biweekly sessions may be recommended." },
];

export default function Support() {
  const [openIdx, setOpenIdx] = useState(null);

  return (
    <div className="content mid-content">
      <div className={styles.welcome}>
        <h2 className={styles.welcomeTitle}>Support</h2>
        <p className={styles.welcomeSub}>Get help and answers to common questions</p>
      </div>

      {/* Contact cards */}
      <div className={styles.contactGrid}>
        <div className={styles.contactCard}>
          <span className={styles.contactIcon}>📞</span>
          <div>
            <div className={styles.contactLabel}>Phone</div>
            <a href={SITE.phoneHref} className={styles.contactLink}>{SITE.phone}</a>
          </div>
        </div>
        <div className={styles.contactCard}>
          <span className={styles.contactIcon}>✉️</span>
          <div>
            <div className={styles.contactLabel}>Email</div>
            <a href={SITE.emailHref} className={styles.contactLink}>{SITE.email}</a>
          </div>
        </div>
      </div>

      {/* FAQ */}
      <div className={styles.card} style={{ marginTop: '1.5rem' }}>
        <div className={styles.cardHeader}>Frequently Asked Questions</div>
        <div className={styles.cardBody}>
          {faqData.map((item, i) => (
            <div key={i} className={`${styles.faqItem} ${openIdx === i ? styles.faqOpen : ''}`}>
              <button className={styles.faqTrigger} onClick={() => setOpenIdx(openIdx === i ? null : i)}>
                <span>{item.q}</span>
                <span className={styles.faqArrow}>{openIdx === i ? '−' : '+'}</span>
              </button>
              <div className={styles.faqAnswer}>
                <p>{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}